import { InvoiceTax } from '../invoice-tax';
import { InvoicePoint } from '../invoice-point';
import { TaxpayerType } from '../taxpayer-type';
import { InvoiceLabelType } from '../invoice-label-type'; 
import { BillingInvoicePeriod } from './billing-invoice-period';
import { ClientSearch } from '../client-search';

export class BillingInvoice {
    public InvoiceTaxes: InvoiceTax[];
    public InvoicePoint: InvoicePoint;
    public InvoiceDate: Date;
    public InvoiceFrom: Date;
    public InvoiceTo: Date;
    public IsRejected?: boolean;
    public IsCirculacionAbierta?: boolean;
    public InvoiceExpiredDate: Date;
    public BillingInvoicePeriod: BillingInvoicePeriod;
    public Description: string;
    public TaxpayerType?: TaxpayerType;
    public InvoiceLabelType?: InvoiceLabelType;
    public Amount: number;
    public AmountWithTax: number;
    public ClientSearch: ClientSearch;
    public OriginalBillingInvoiceId?: number;
    public OriginalBillingInvoiceManualId?: number;
    public OriginalBillingInvoiceDate?: Date;
    public OriginalAmount?: number;
    public OriginalInvoiceNumberBookTypeId?: number;
    public OriginalCompanyId?: number;
    public OriginalIIBBTaxAliquotId?: number;
}
